// extracted by mini-css-extract-plugin
module.exports = {"container":"transcipt-preview-image_container__7qz1e","image":"transcipt-preview-image_image__3DzTO"};